import menus from './menuRoles';

export function isMenuEligible(userType, location) {
  let el_count = 0;

  menus.forEach((menu) => {
    if (location?.pathname?.includes(menu.path) && !menu?.eligible?.includes(userType)) {
      // console.log('check pathname', location.pathname);
      // console.log('check path', menu.path);
      // console.log('check userType', userType);
      if (location.pathname === '/portal/moderation/detail' && userType === 'contributor') return;
      el_count += 1;
    }
  });

  if (el_count > 0) return false;

  return true;
}

export function isFunctionEligible(userType, key) {
  const allRoles = ['editor', 'admin', 'verificator', 'contributor'];
  if (key === 'add_comment_section' && ['editor', 'verificator', 'admin'].includes(userType)) return true;
  if (key === 'update_review_section' && ['editor', 'verificator', 'admin'].includes(userType)) return true;
  if (key === 'button_review' && ['editor', 'verificator', 'admin'].includes(userType)) return true;
  if (key === 'button_edit' && ['editor', 'verificator', 'admin'].includes(userType)) return true;
  if (key === 'button_review_edit' && ['editor', 'verificator', 'admin'].includes(userType)) return true;
  if (key === 'button_form_update' && ['editor', 'admin', 'contributor'].includes(userType)) return true;
  if (key === 'button_form_delete' && ['admin'].includes(userType)) return true;
  if (key === 'update_document_status' && ['editor', 'admin'].includes(userType)) return true;
  if (key === 'update_rank_flag' && ['editor', 'admin'].includes(userType)) return true;
  if (key === 'fab_portal') return true;
  return false;
}
